enum OtherEnum {
  'imprint.meta_title' = 'imprint.meta_title',
  'imprint.imprint' = 'imprint.imprint',
  'imprint.operator_of_website' = 'imprint.operator_of_website',
  'imprint.germany' = 'imprint.germany',
  'imprint.phone_number' = 'imprint.phone_number',
  'imprint.email' = 'imprint.email',
  'imprint.managing_partners' = 'imprint.managing_partners',
  'imprint.register_court' = 'imprint.register_court',
  'imprint.local_court_of_munich' = 'imprint.local_court_of_munich',
  'imprint.registration_number' = 'imprint.registration_number',
  'imprint.vat_identification' = 'imprint.vat_identification',
  'imprint.responsible_of_content' = 'imprint.responsible_of_content',
  'imprint.online_dispute_resolution' = 'imprint.online_dispute_resolution',
  'imprint.online_dispute_resolution_subtitle' = 'imprint.online_dispute_resolution_subtitle',
  'imprint.online_dispute_resolution_2' = 'imprint.online_dispute_resolution_2',
  'imprint.this_imprint_applies' = 'imprint.this_imprint_applies',
  'imprint.address_as' = 'imprint.address_as',
  'imprint.photos_credit_intro' = 'imprint.photos_credit_intro',
  'imprint.photos_credit_final' = 'imprint.photos_credit_final',
  'terms.meta_title' = 'terms.meta_title',
  'terms.terms_and_conditions' = 'terms.terms_and_conditions',
  'terms.first_header' = 'terms.first_header',
  'terms.first_paragraph' = 'terms.first_paragraph',
  'terms.first_list.first_item.strong' = 'terms.first_list.first_item.strong',
  'terms.first_list.first_item.text' = 'terms.first_list.first_item.text',
  'terms.first_list.second_item.strong' = 'terms.first_list.second_item.strong',
  'terms.first_list.second_item.text' = 'terms.first_list.second_item.text',
  'terms.first_list.third_item.strong' = 'terms.first_list.third_item.strong',
  'terms.first_list.third_item.text' = 'terms.first_list.third_item.text',
  'terms.first_list.fourth_item.strong' = 'terms.first_list.fourth_item.strong',
  'terms.first_list.fourth_item.text' = 'terms.first_list.fourth_item.text',
  'terms.first_list.fifth_item.strong' = 'terms.first_list.fifth_item.strong',
  'terms.first_list.fifth_item.text' = 'terms.first_list.fifth_item.text',
  'terms.first_list.end_list' = 'terms.first_list.end_list',
  'terms.second_header' = 'terms.second_header',
  'terms.second_paragraph' = 'terms.second_paragraph',
  'terms.third_paragraph' = 'terms.third_paragraph',
  'terms.fourth_paragraph' = 'terms.fourth_paragraph',
  'terms.fifth_paragraph.strong' = 'terms.fifth_paragraph.strong',
  'terms.fifth_paragraph.text_1' = 'terms.fifth_paragraph.text_1',
  'terms.fifth_paragraph.text_2' = 'terms.fifth_paragraph.text_2',
  'terms.sixth_paragraph' = 'terms.sixth_paragraph',
  'terms.third_header' = 'terms.third_header',
  'terms.seventh_paragraph' = 'terms.seventh_paragraph',
  'terms.eighth_paragraph' = 'terms.eighth_paragraph',
  'terms.ninth_paragraph' = 'terms.ninth_paragraph',
  'terms.fourth_header' = 'terms.fourth_header',
  'terms.tenth_paragraph' = 'terms.tenth_paragraph',
  'terms.fifth_header' = 'terms.fifth_header',
  'terms.eleventh_paragraph' = 'terms.eleventh_paragraph',
  'terms.twelfth_paragraph' = 'terms.twelfth_paragraph',
  'terms.sixth_header' = 'terms.sixth_header',
  'terms.thirteenth_paragraph' = 'terms.thirteenth_paragraph',
  'terms.fourteenth_paragraph' = 'terms.fourteenth_paragraph',
  'terms.fifteenth_paragraph' = 'terms.fifteenth_paragraph',
  'terms.sixteenth_paragraph' = 'terms.sixteenth_paragraph',
  'terms.seventh_header' = 'terms.seventh_header',
  'terms.seventeenth_paragraph' = 'terms.seventeenth_paragraph',
  'terms.eighteenth_paragraph' = 'terms.eighteenth_paragraph',
  'terms.eighth_header' = 'terms.eighth_header',
  'terms.ninetheen_paragraph' = 'terms.ninetheen_paragraph',
  'terms.ninth_header' = 'terms.ninth_header',
  'terms.twentieth_paragraph' = 'terms.twentieth_paragraph',
  'terms.tenth_header' = 'terms.tenth_header',
  'terms.twenty_first_paragraph' = 'terms.twenty_first_paragraph',
  'terms.second_list.first_item' = 'terms.second_list.first_item',
  'terms.second_list.second_item' = 'terms.second_list.second_item',
  'terms.twenty_second_paragraph' = 'terms.twenty_second_paragraph',
  'terms.third_list.first_item' = 'terms.third_list.first_item',
  'terms.third_list.second_item' = 'terms.third_list.second_item',
  'terms.third_list.third_item' = 'terms.third_list.third_item',
  'terms.third_list.fourth_item' = 'terms.third_list.fourth_item',
  'terms.third_list.fifth_item' = 'terms.third_list.fifth_item',
  'terms.twenty_third_paragraph' = 'terms.twenty_third_paragraph',
  'terms.twenty_fourth_paragraph' = 'terms.twenty_fourth_paragraph',
  'terms.twenty_fifth_paragraph' = 'terms.twenty_fifth_paragraph',
  'terms.twenty_sixth_paragraph' = 'terms.twenty_sixth_paragraph',
  'terms.twenty_seventh_paragraph' = 'terms.twenty_seventh_paragraph',
  'terms.twenty_eighth_paragraph' = 'terms.twenty_eighth_paragraph',
  'terms.twenty_ninth_paragraph' = 'terms.twenty_ninth_paragraph',
  'terms.eleventh_header' = 'terms.eleventh_header',
  'terms.thirtieth_paragraph' = 'terms.thirtieth_paragraph',
  'terms.thirty_first_paragraph' = 'terms.thirty_first_paragraph',
  'terms.thirty_second_paragraph' = 'terms.thirty_second_paragraph',
  'terms.twelfth_header' = 'terms.twelfth_header',
  'terms.thirty_third_paragraph' = 'terms.thirty_third_paragraph',
  'terms.thirteenth_header' = 'terms.thirteenth_header',
  'terms.thirty_fourth_paragraph' = 'terms.thirty_fourth_paragraph',
  'terms.fourteenth_header' = 'terms.fourteenth_header',
  'terms.thirty_fifth_paragraph' = 'terms.thirty_fifth_paragraph',
  'terms.updated_at' = 'terms.updated_at',
  'terms.germany' = 'terms.germany',
  'terms.munich' = 'terms.munich',
  'data_privacy.meta_title' = 'data_privacy.meta_title',
  'data_privacy.privacy_policy' = 'data_privacy.privacy_policy',
  'data_privacy.p_1' = 'data_privacy.p_1',
  'data_privacy.h_1' = 'data_privacy.h_1',
  'data_privacy.p_2' = 'data_privacy.p_2',
  'data_privacy.ul_1.li_1' = 'data_privacy.ul_1.li_1',
  'data_privacy.ul_1.li_2' = 'data_privacy.ul_1.li_2',
  'data_privacy.ul_1.li_3' = 'data_privacy.ul_1.li_3',
  'data_privacy.ul_1.li_4' = 'data_privacy.ul_1.li_4',
  'data_privacy.ul_1.li_5' = 'data_privacy.ul_1.li_5',
  'data_privacy.p_3.text_1' = 'data_privacy.p_3.text_1',
  'data_privacy.p_3.text_2' = 'data_privacy.p_3.text_2',
  'data_privacy.p_3.text_3' = 'data_privacy.p_3.text_3',
  'data_privacy.p_3.text_4' = 'data_privacy.p_3.text_4',
  'data_privacy.section_1.title' = 'data_privacy.section_1.title',
  'data_privacy.section_1.text_1' = 'data_privacy.section_1.text_1',
  'data_privacy.section_1.text_2' = 'data_privacy.section_1.text_2',
  'data_privacy.section_1.text_3' = 'data_privacy.section_1.text_3',
  'data_privacy.section_2.title_1' = 'data_privacy.section_2.title_1',
  'data_privacy.section_2.p_4' = 'data_privacy.section_2.p_4',
  'data_privacy.section_2.p_5' = 'data_privacy.section_2.p_5',
  'data_privacy.section_2.ul_1.li_1' = 'data_privacy.section_2.ul_1.li_1',
  'data_privacy.section_2.ul_1.li_2' = 'data_privacy.section_2.ul_1.li_2',
  'data_privacy.section_2.ul_1.li_3' = 'data_privacy.section_2.ul_1.li_3',
  'data_privacy.section_2.ul_1.li_4' = 'data_privacy.section_2.ul_1.li_4',
  'data_privacy.section_2.p_6' = 'data_privacy.section_2.p_6',
  'data_privacy.section_2.title_2' = 'data_privacy.section_2.title_2',
  'data_privacy.section_2.p_7' = 'data_privacy.section_2.p_7',
  'data_privacy.section_2.title_3' = 'data_privacy.section_2.title_3',
  'data_privacy.section_2.p_8' = 'data_privacy.section_2.p_8',
  'data_privacy.section_2.title_4' = 'data_privacy.section_2.title_4',
  'data_privacy.section_2.p_9' = 'data_privacy.section_2.p_9',
  'data_privacy.section_2.title_5' = 'data_privacy.section_2.title_5',
  'data_privacy.section_2.p_10' = 'data_privacy.section_2.p_10',
  'data_privacy.section_2.title_6' = 'data_privacy.section_2.title_6',
  'data_privacy.section_2.p_11' = 'data_privacy.section_2.p_11',
  'data_privacy.section_3.title_1' = 'data_privacy.section_3.title_1',
  'data_privacy.section_3.p_12' = 'data_privacy.section_3.p_12',
  'data_privacy.section_3.p_13' = 'data_privacy.section_3.p_13',
  'data_privacy.section_3.p_14' = 'data_privacy.section_3.p_14',
  'data_privacy.section_3.p_15' = 'data_privacy.section_3.p_15',
  'data_privacy.section_3.title_2' = 'data_privacy.section_3.title_2',
  'data_privacy.section_3.p_16' = 'data_privacy.section_3.p_16',
  'data_privacy.section_3.title_3' = 'data_privacy.section_3.title_3',
  'data_privacy.section_3.title_4' = 'data_privacy.section_3.title_4',
  'data_privacy.section_3.title_5' = 'data_privacy.section_3.title_5',
  'data_privacy.section_3.p_17' = 'data_privacy.section_3.p_17',
  'data_privacy.section_3.p_18' = 'data_privacy.section_3.p_18',
  'data_privacy.section_3.title_6' = 'data_privacy.section_3.title_6',
  'data_privacy.section_3.p_19' = 'data_privacy.section_3.p_19',
  'data_privacy.section_3.p_20' = 'data_privacy.section_3.p_20',
  'data_privacy.section_3.p_21' = 'data_privacy.section_3.p_21',
  'data_privacy.section_3.p_22' = 'data_privacy.section_3.p_22',
  'data_privacy.section_3.p_23' = 'data_privacy.section_3.p_23',
  'data_privacy.section_3.p_24' = 'data_privacy.section_3.p_24',
  'data_privacy.section_4.title_1' = 'data_privacy.section_4.title_1',
  'data_privacy.section_4.title_2' = 'data_privacy.section_4.title_2',
  'data_privacy.section_4.p_25' = 'data_privacy.section_4.p_25',
  'data_privacy.section_4.title_3' = 'data_privacy.section_4.title_3',
  'data_privacy.section_4.title_4' = 'data_privacy.section_4.title_4',
  'data_privacy.section_4.p_26' = 'data_privacy.section_4.p_26',
  'data_privacy.section_4.title_5' = 'data_privacy.section_4.title_5',
  'data_privacy.section_4.p_27' = 'data_privacy.section_4.p_27',
  'data_privacy.section_4.title_6' = 'data_privacy.section_4.title_6',
  'data_privacy.section_4.p_28' = 'data_privacy.section_4.p_28',
  'data_privacy.section_4.title_7' = 'data_privacy.section_4.title_7',
  'data_privacy.section_4.p_29' = 'data_privacy.section_4.p_29',
  'data_privacy.section_4.title_8' = 'data_privacy.section_4.title_8',
  'data_privacy.section_4.p_30' = 'data_privacy.section_4.p_30',
  'data_privacy.section_5.title_1' = 'data_privacy.section_5.title_1',
  'data_privacy.section_5.title_2' = 'data_privacy.section_5.title_2',
  'data_privacy.section_5.p_31' = 'data_privacy.section_5.p_31',
  'data_privacy.section_5.title_3' = 'data_privacy.section_5.title_3',
  'data_privacy.section_5.p_32' = 'data_privacy.section_5.p_32',
  'data_privacy.section_5.p_33' = 'data_privacy.section_5.p_33',
  'data_privacy.section_5.p_34' = 'data_privacy.section_5.p_34',
  'data_privacy.section_5.title_4' = 'data_privacy.section_5.title_4',
  'data_privacy.section_5.p_35' = 'data_privacy.section_5.p_35',
  'data_privacy.section_5.title_5' = 'data_privacy.section_5.title_5',
  'data_privacy.section_5.p_36' = 'data_privacy.section_5.p_36',
  'data_privacy.section_5.title_6' = 'data_privacy.section_5.title_6',
  'data_privacy.section_5.p_37' = 'data_privacy.section_5.p_37',
  'data_privacy.section_5.title_7' = 'data_privacy.section_5.title_7',
  'data_privacy.section_5.p_38' = 'data_privacy.section_5.p_38',
  'data_privacy.section_5.title_8' = 'data_privacy.section_5.title_8',
  'data_privacy.section_5.p_39' = 'data_privacy.section_5.p_39',
  'data_privacy.section_6.title_1' = 'data_privacy.section_6.title_1',
  'data_privacy.section_6.p_40' = 'data_privacy.section_6.p_40',
  'data_privacy.section_6.title_2' = 'data_privacy.section_6.title_2',
  'data_privacy.section_6.p_41' = 'data_privacy.section_6.p_41',
  'data_privacy.section_6.p_42' = 'data_privacy.section_6.p_42',
  'data_privacy.section_7.title_1' = 'data_privacy.section_7.title_1',
  'data_privacy.section_7.p_1' = 'data_privacy.section_7.p_1',
  'data_privacy.section_7.p_2' = 'data_privacy.section_7.p_2',
  'data_privacy.section_7.subsection_1.title' = 'data_privacy.section_7.subsection_1.title',
  'data_privacy.section_7.subsection_1.items.0' = 'data_privacy.section_7.subsection_1.items.0',
  'data_privacy.section_7.subsection_2.title' = 'data_privacy.section_7.subsection_2.title',
  'data_privacy.section_7.subsection_2.items.0' = 'data_privacy.section_7.subsection_2.items.0',
  'data_privacy.section_7.subsection_3.title' = 'data_privacy.section_7.subsection_3.title',
  'data_privacy.section_7.subsection_3.items.0' = 'data_privacy.section_7.subsection_3.items.0',
  'data_privacy.section_7.subsection_4.title' = 'data_privacy.section_7.subsection_4.title',
  'data_privacy.section_7.subsection_4.items.0' = 'data_privacy.section_7.subsection_4.items.0',
  'data_privacy.section_7.subsection_5.title' = 'data_privacy.section_7.subsection_5.title',
  'data_privacy.section_7.subsection_5.items.0' = 'data_privacy.section_7.subsection_5.items.0',
  'data_privacy.section_7.subsection_6.title' = 'data_privacy.section_7.subsection_6.title',
  'data_privacy.section_7.subsection_6.items.0' = 'data_privacy.section_7.subsection_6.items.0',
  'data_privacy.section_7.subsection_6.items.1' = 'data_privacy.section_7.subsection_6.items.1',
  'data_privacy.section_7.subsection_6.items.2' = 'data_privacy.section_7.subsection_6.items.2',
  'data_privacy.section_7.subsection_6.items.3' = 'data_privacy.section_7.subsection_6.items.3',
  'data_privacy.section_7.subsection_6.items.4' = 'data_privacy.section_7.subsection_6.items.4',
  'data_privacy.section_7.subsection_7.title' = 'data_privacy.section_7.subsection_7.title',
  'data_privacy.section_7.subsection_7.items.0' = 'data_privacy.section_7.subsection_7.items.0',
  'data_privacy.section_7.subsection_7.items.1' = 'data_privacy.section_7.subsection_7.items.1',
  'data_privacy.section_7.subsection_8.title' = 'data_privacy.section_7.subsection_8.title',
  'data_privacy.section_7.subsection_8.items.0' = 'data_privacy.section_7.subsection_8.items.0',
  'data_privacy.section_8.title_1' = 'data_privacy.section_8.title_1',
  'data_privacy.section_8.p_43' = 'data_privacy.section_8.p_43',
  'data_privacy.section_9.title_1' = 'data_privacy.section_9.title_1',
  'data_privacy.section_9.p_44' = 'data_privacy.section_9.p_44',
  'cookie_policy.header.title' = 'cookie_policy.header.title',
  'cookie_policy.section_1.p_1' = 'cookie_policy.section_1.p_1',
  'cookie_policy.section_1.p_2' = 'cookie_policy.section_1.p_2',
  'cookie_policy.section_2.title' = 'cookie_policy.section_2.title',
  'cookie_policy.section_2.p_3' = 'cookie_policy.section_2.p_3',
  'cookie_policy.section_2.p_4' = 'cookie_policy.section_2.p_4',
  'cookie_policy.section_2.p_5' = 'cookie_policy.section_2.p_5',
  'cookie_policy.section_3.title' = 'cookie_policy.section_3.title',
  'cookie_policy.section_3.p_1' = 'cookie_policy.section_3.p_1',
  'cookie_policy.section_3.p_2' = 'cookie_policy.section_3.p_2',
  'cookie_policy.section_3.p_3' = 'cookie_policy.section_3.p_3',
  'cookie_policy.section_4.title' = 'cookie_policy.section_4.title',
  'cookie_policy.section_4.p_1' = 'cookie_policy.section_4.p_1',
  'cookie_policy.section_4.p_2' = 'cookie_policy.section_4.p_2',
  'cookie_policy.section_4.listing_title' = 'cookie_policy.section_4.listing_title',
  'cookie_policy.section_4.table.header.company' = 'cookie_policy.section_4.table.header.company',
  'cookie_policy.section_4.table.header.purpose' = 'cookie_policy.section_4.table.header.purpose',
  'cookie_policy.section_4.table.header.cookies' = 'cookie_policy.section_4.table.header.cookies',
  'cookie_policy.section_4.table.company_1' = 'cookie_policy.section_4.table.company_1',
  'cookie_policy.section_4.table.company_2' = 'cookie_policy.section_4.table.company_2',
  'cookie_policy.section_4.table.company_3' = 'cookie_policy.section_4.table.company_3',
  'cookie_policy.section_5.title' = 'cookie_policy.section_5.title',
  'cookie_policy.section_5.p_1' = 'cookie_policy.section_5.p_1',
  'cookie_policy.section_5.p_2' = 'cookie_policy.section_5.p_2',
  'cookie_policy.section_5.listing_title' = 'cookie_policy.section_5.listing_title',
  'cookie_policy.section_5.table.header.company' = 'cookie_policy.section_5.table.header.company',
  'cookie_policy.section_5.table.header.purpose' = 'cookie_policy.section_5.table.header.purpose',
  'cookie_policy.section_5.table.header.cookies' = 'cookie_policy.section_5.table.header.cookies',
  'cookie_policy.section_5.table.row_google_analytics.company' = 'cookie_policy.section_5.table.row_google_analytics.company',
  'cookie_policy.section_5.table.row_google_analytics.purpose_de' = 'cookie_policy.section_5.table.row_google_analytics.purpose_de',
  'cookie_policy.section_5.table.row_google_analytics.link' = 'cookie_policy.section_5.table.row_google_analytics.link',
  'cookie_policy.section_5.table.row_google_analytics.linkText_de' = 'cookie_policy.section_5.table.row_google_analytics.linkText_de',
  'cookie_policy.final_section.button_text' = 'cookie_policy.final_section.button_text',
  'cookie_policy.final_section.acceptance_statement' = 'cookie_policy.final_section.acceptance_statement',
  'cookie_policy.performance_cookies' = 'cookie_policy.performance_cookies',
  'investors.meta_title' = 'investors.meta_title',
  'investors.title' = 'investors.title',
  'investors.content' = 'investors.content',
  'investors.button_text' = 'investors.button_text',
  'press.meta_title' = 'press.meta_title',
  'press.title' = 'press.title',
  'press.the_founders' = 'press.the_founders',
  'press.subtitle' = 'press.subtitle',
  'press.item1' = 'press.item1',
  'press.item2' = 'press.item2',
  'press.item3' = 'press.item3',
  'press.item4' = 'press.item4',
  'press.item5' = 'press.item5',
  'press.founders.janis.item1' = 'press.founders.janis.item1',
  'press.founders.janis.item2' = 'press.founders.janis.item2',
  'press.founders.janis.item3' = 'press.founders.janis.item3',
  'press.founders.janis.item4' = 'press.founders.janis.item4',
  'press.founders.janis.item5' = 'press.founders.janis.item5',
  'press.founders.clemens.item1' = 'press.founders.clemens.item1',
  'press.founders.clemens.item2' = 'press.founders.clemens.item2',
  'press.founders.clemens.item3' = 'press.founders.clemens.item3',
  'press.global_idea.title' = 'press.global_idea.title',
  'press.global_idea.p1' = 'press.global_idea.p1',
  'press.global_idea.p2' = 'press.global_idea.p2',
  'press.global_idea.p3' = 'press.global_idea.p3',
  'press.global_idea.p4' = 'press.global_idea.p4',
  'press.global_idea.p5' = 'press.global_idea.p5',
  'press.press_download' = 'press.press_download',
  'press.logos' = 'press.logos',
  'press.photos_various' = 'press.photos_various',
  'press.our_partners_and_supporters' = 'press.our_partners_and_supporters',
  'press.do_you_have_any_questions' = 'press.do_you_have_any_questions',
  'press.contact_person' = 'press.contact_person',
  'press.press_releases_signup' = 'press.press_releases_signup',
  'press.press_releases_signup_description' = 'press.press_releases_signup_description',
  'press.validation.email_invalid' = 'press.validation.email_invalid',
  'press.validation.email_required' = 'press.validation.email_required',
  'press.email_address' = 'press.email_address',
  'press.subscribed' = 'press.subscribed',
  'press.subscribe' = 'press.subscribe',
  'press.thank_you_for_subscribing' = 'press.thank_you_for_subscribing',
  'press.unknown_error_while_subscribing' = 'press.unknown_error_while_subscribing',
}

export { OtherEnum };